<template>
  <HScaffold title="个人资料">
    <div class="tProfileParentDiv">
      <HCellGroup :data="cellGroupData"/>
      <HCellGroup :data="cellGroupData2"/>
      <HServicePrase/>
      <div v-if="HNewGameUIConfig.newGameUIType !== 0" style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
        <div :style="hcf.getTextStyle({
          color:'#999',marginTop:20,
        })">Ver: {{hdi.appVersion}}</div>
      </div>
      <van-action-sheet
          v-model:show="showGender"
          :actions="actions"
          cancel-text="取消"
          close-on-click-action
          @select="onSelect"
      />
      <van-action-sheet v-model:show="showBirthDay">
        <van-date-picker
            v-model="currentDate"
            title="选择出生年月"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="()=>{
              showBirthDay = false;
            }"
            @confirm="selectBirthday"
        />
      </van-action-sheet>
    </div>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import {showToast} from "vant";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HCellGroup from "@/components/utils/HCellGroup.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import HServicePrase from "@/components/utils/HServicePrase.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hdi} from "../../utils/HDeviceInfo.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let useUser = useUserStore();
  let useHttp = useHHttp();
  let useComApi = useHComApi();
  const showGender = ref(false);
  const actions = [
    {name: '男'},
    {name: '女'},
  ];
  const showBirthDay = ref(false);
  const currentDate = ref(['2000', '01', '01']);
  let minDate = new Date(1925, 0, 1);
  let maxDate = new Date(2025, 0, 1);
  const onSelect = (item) => {
    // 默认情况下点击选项时不会自动收起
    // 可以通过 close-on-click-action 属性开启自动收起
    let tempValue = item.name === "男" ? 1 : 2;
    useComApi.modifyUserBase({
      "Gender": tempValue,
    }, () => {
      useUser.gender = tempValue;
      updateGroupData2();
    });
  };
  function selectBirthday(data){
    let tempArray = data["selectedValues"];
    let birthday = tempArray[0]+"-"+tempArray[1]+"-"+tempArray[2];
    useComApi.modifyUserBase({
      "Birth": birthday,
    }, () => {
      useUser.birthday = birthday;
      updateGroupData2();
      showBirthDay.value = false;
    });
  }

  const cellGroupData = ref([
    {
      "title": "账号ID",
      "rightText": useUser.userId,
      "callBack":()=>{
        hcf.copyClipboard(useUser.userId);
      }
    },
    {
      "title": "用户名",
      "rightText": useUser.userName === ""
          ? "点击添加"
          : useUser.userName,
      "callBack": useUser.userName === ""
          ? () => {
            hr.go("editor", {
              "hintText": "是英文与数字组合(英文字母开头)",
              "title": "添加用户名",
              "onlyCharAndNumber": true,
              "successCallBack": (value) => {
                useHttp.request("/app/reg/username/bind",
                    () => {
                      showToast("用户名添加成功");
                      useUser.userName =
                          value;
                      hr.goBack();
                    }, {
                      params: {
                        "AppId": useUser.appId,
                        "UserName": value,
                        "UserId":
                        useUser.userId,
                      }
                    });
              }
            });
          }
          : null
    },
    {
      "title": "真实姓名",
      "hintText": useUser.realName === "" ? "姓名必须与银行持卡人一致" : "",
      "rightText": useUser.realName === ""
          ? "去实名"
          : useUser.realName,
      "callBack": useUser.realName === ""
          ? () => {
            hr.go("editor", {
              "hintText": "姓名必须与银行持卡人一致",
              "title": "设置真实姓名",
              "successCallBack": (value) => {

                useComApi.modifyUserBase({
                  "RealName": value,
                }, () => {
                  showToast("姓名添加成功");
                  useUser.realName =
                      value;
                  hr.goBack();
                });

              }
            });
          }
          : null
    },
  ]);
  const cellGroupData2 = ref([]);
  updateGroupData2();

  function updateGroupData2() {
    cellGroupData2.value = [
      {
        "title": "性别",
        "rightText": useUser.gender === 0
            ? "选择后无法再次修改"
            : useUser.gender === 1
                ? "男"
                : "女",
        "callBack": useUser.gender === 0
            ? () => {
              showGender.value = true;
            }
            :
            null
      },
      {
        "title":
            "出生年月",
        "rightText":
            useUser.birthday === ""
                ? "选择后无法再次修改"
                : useUser.birthday,
        "callBack":
            useUser.birthday === ""
                ? () => {
                  showBirthDay.value = true;
                }
                :
                null
      },
      {
        "title":
            "收货地址",
        "hintText": useUser.addressList.length <= 0 ? "实物奖将通过收货地址发送 (最多添加3条)" : "",
        "rightText":
            useUser.addressList.length <= 0
                ? "去添加"
                : "已添加"+useUser.addressList.length+"条地址",
        "callBack":
            () => {
              hr.go("address");
            }
      },
    ];
  }
</script>


<style scoped>

  .tProfileParentDiv {
    display: flex;
    flex-direction: column;
  }

</style>
